import { createAction, props } from '@ngrx/store';

export enum Type {
  ALL_LOCATIONS_REQUEST_GET = '[HOTELS] Get All locations Request ',
  ALL_LOCATIONS_REQUEST_SUCCESS = '[HOTELS] Get All locations Request Success',
  HOTELS_REQUEST_GET = '[HOTELS] Request Get',
  LANDING_FILTER_REQUEST_GET = '[HOTELS] Landing Filter Request Get',
  HOTELS_REQUEST_SUCCESS = '[HOTELS] Request Success',
  HOTELS_REQUEST_ERROR = '[HOTELS] Request Error',
  TOGGLE_FILTER = '[HOTELS] Toggle Filter',
  TOGGLE_MAP = '[HOTELS] Toggle Map',
  RECOMMENDED_HOTELS_REQUEST_GET = '[HOTELS] Recommended hotels request Get',
  RECOMMENDED_HOTELS_REQUEST_SUCCESS = '[HOTELS] Recommended hotels request Success',
}

/*export class HotelsRequestGet implements Action {
  public readonly type = Type.HOTELS_REQUEST_GET;
  constructor(public payload: any) {}
}*/
export const hotelRequestGet = createAction(Type.HOTELS_REQUEST_GET, props<{ payload: any }>());
/*export class LandingFilterRequestGet implements Action {
  public readonly type = Type.LANDING_FILTER_REQUEST_GET;
  constructor(public payload: any) {}
}*/

export const landigFilterRequestGet = createAction(
  Type.LANDING_FILTER_REQUEST_GET,
  props<{ payload: any }>(),
);
/*export class HotelsRequestSuccess implements Action {
  public readonly type = Type.HOTELS_REQUEST_SUCCESS;
  constructor(public payload: any) {}
}*/

export const hotelsRequestSuccess = createAction(
  Type.HOTELS_REQUEST_SUCCESS,
  props<{ payload: any }>(),
);
/*
export class HotelsRequestError implements Action {
  public readonly type = Type.HOTELS_REQUEST_ERROR;
  constructor(public payload: any) {}
}*/

export const hotelRequestError = createAction(Type.HOTELS_REQUEST_ERROR, props<{ payload: any }>());

/*export class ToggleFilter implements Action {
  public readonly type = Type.TOGGLE_FILTER;
  constructor(public payload: any) {}
}
*/
export const toggleFilter = createAction(Type.TOGGLE_FILTER, props<{ payload: any }>());

/*export class ToggleMap implements Action {
  public readonly type = Type.TOGGLE_MAP;
  constructor(public payload: { viewMap: boolean; imageStyle?: boolean }) {}
}*/

export const toggleMap = createAction(
  Type.TOGGLE_MAP,
  props<{ payload: { viewMap: boolean; imageStyle?: boolean } }>(),
);
/*
export class AllLocationRequestGet implements Action {
  public readonly type = Type.ALL_LOCATIONS_REQUEST_GET;
  constructor(public payload: any) {}
}*/

export const allLocationRequestGet = createAction(
  Type.ALL_LOCATIONS_REQUEST_GET,
  props<{ payload: any }>(),
);
/*
export class AllLocationRequestSuccess implements Action {
  public readonly type = Type.ALL_LOCATIONS_REQUEST_SUCCESS;
  constructor(public payload: any) {}
}*/

export const allLocationRequestSuccess = createAction(
  Type.ALL_LOCATIONS_REQUEST_SUCCESS,
  props<{ payload: any }>(),
);
/*
export class RecommendedHotelsRequestGet implements Action {
  public readonly type = Type.RECOMMENDED_HOTELS_REQUEST_GET;
  constructor(public payload: any) {}
}
*/

export const recommendedHostelRequestGet = createAction(
  Type.RECOMMENDED_HOTELS_REQUEST_GET,
  props<{ payload: any }>(),
);
/*
export class RecommendedHotelsRequestSuccess implements Action {
  public readonly type = Type.RECOMMENDED_HOTELS_REQUEST_SUCCESS;
  constructor(public payload: any) {}
}*/
export const recommendedHotelRequestSuccess = createAction(
  Type.RECOMMENDED_HOTELS_REQUEST_SUCCESS,
  props<{ payload: any }>(),
);
